// DB module format
export interface IntegrityMonitorModule {
  realTime: IntegrityMonitorRealTimeSection;
}

export interface IntegrityMonitorRealTimeSection {
  enabled: boolean;
  ruleProcessingMode: IntegrityMonitorRuleProcessingModeOption;
  mode: IntegrityMonitorMode;
  ruleSetIds: Array<string>;
}

// enums for ui settings
export enum IntegrityMonitorMode {
  BASELINE = 1,
  RULE_SETS = 2,
}

export enum IntegrityMonitorRuleProcessingModeOption {
  FAST = 'high',
  NORMAL = 'medium',
  SLOW = 'low',
}
